module.exports = __webpack_public_path__ + "static/media/MERCURE_SAO_PAULO_PAULISTA.72478699.png";